import React from 'react';
import {UnderConstruction} from "./portfolio/projects/UnderConstruction";


export const Blog = props => {
    return (
        <div>
            <UnderConstruction />
        </div>
    )
};
